export enum Language {
  ENGLISH = "en",
  SPANISH = "es",
  ITALIAN = "it",
  PORTUGUESE = "pt",
}
